import { createAction } from '@reduxjs/toolkit';

export const actionToggleSidebar = createAction<boolean>('app/actionToggleSidebar');